import React, { useState } from "react";
import { ReactComponent as AutofillClose } from "../../assets/images/icons/AutofillClose.svg";
import { ReactComponent as AutofillOpen } from "../../assets/images/icons/AutofillOpen.svg";
import { ReactComponent as AutofillDrop } from "../../assets/images/icons/autofillDrop.svg";
import Button from "../UniversalComponents/DefaultButton";
import FileAttachment from "../UniversalComponents/FileAttachment";
const additionalText = (
  <div className="text-xs text-[#AFAFAF] font-normal">
    <p>Supported formats: PDF, PNG, JPEG</p>
    {/* <p>Upload your document Maximum Size 10 MB</p> */}
  </div>
);
const AutofillBill = ({ handleAiExtractor = () => {}, height = "h-[850px]" }) => {
  const [file, setFile] = useState([]);
  return (
    <>
      <div className={`w-[20%] min-w-[360px] bg-white  border-BECBD3 border-[1px] rounded-md ${height}`}>
        <div className="flex justify-between items-center p-2 px-4 border-b-[1px] border-BECBD3">
          <h2 className="text-16 font-500 text-434852">Autofill Bill</h2>
          <button onClick={handleAiExtractor}>
            <AutofillClose />
          </button>
        </div>
        <div className="p-4 flex flex-col justify-between h-[95%]">
          <div>
            <div className="flex items-center justify-between border bg-F4F4F4 p-2 rounded-[5px] border-EAE2E2">
              <h2 className="text-12 font-500 text-535252 ">Upload from this device</h2>
              <AutofillOpen />
            </div>
            <div className=" border-dashed border-[1px] border-[#BCD0E3] mt-4 h-[300px] items-center justify-center flex flex-col rounded-[5px] gap-2">
              {/* <div>
                <h2 className="text-12 font-500 text-[#7C7C7C] flex flex-col text-center">
                  or drag and drop here <span className="text-AFAFAF"> Supported formats: PDF, PNG, JPEG</span>
                </h2>
              </div> */}
              <div className="flex flex-col items-center">
                <FileAttachment
                  onChange={(file) => setFile(file)}
                  maxSize={10}
                  label="Upload your document"
                  id={"AiFileUpload"}
                  name={"AiFileUpload"}
                  value={file || []}
                  error={""}
                  additionalText={additionalText}
                />
                <Button
                  type="secondary"
                  style={{
                    backgroundColor: "#1D4469",
                    borderColor: "#123251",
                    color: "#fff",
                    height: "35px",
                    fontSize: "12px",
                    display: "flex",
                    gap: "8px",
                    alignItems: "center",
                  }}
                >
                  Autofill From File
                  <AutofillDrop />
                </Button>
              </div>
            </div>
          </div>
          <div className="flex justify-end ">
            <Button type="primary" style={{ color: "#535252", height: "35px" }} onClick={handleAiExtractor}>
              CANCEL
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default AutofillBill;
